import React, { useEffect, useMemo, useState } from 'react';
import {
  isMobile,
  parseNumberByPrecision,
  userInfoStore,
  useTranslation,
} from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { gameStore } from '../../store/gameStore';
import { parseOddByPrecision } from '../../helpers/parseOddByPrecision';
import { globalTranslationKeys } from '../../enums/translationKeys';

export const CurrentRoundTotalOdds = observer(() => {
  const { reportResult: reportList } = gameStore;
  const { precision } = userInfoStore;

  const t = useTranslation();
  const [showPulsing, setShowPulsing] = useState(false);

  const totalOdd = useMemo(() => {
    const list = [...reportList];
    list.reverse();

    const odd = list?.reduce((acum, current) => {
      return current?.odd || (list?.length && !list?.[0]?.odd)
        ? parseNumberByPrecision(acum, current?.odd, precision, true)
        : acum;
    }, 1);
    return parseOddByPrecision(odd, precision);
  }, [reportList]);

  useEffect(() => {
    setShowPulsing(true);
    setTimeout(() => setShowPulsing(false), 500);
    return () => {
      setShowPulsing(false);
    };
  }, [totalOdd, reportList.length]);

  // const additionalOddClassName = useMemo(() => {
  //   if (totalOdd && isMobile()) {
  //     const stringOdd = totalOdd.toString();
  //
  //     if (stringOdd.length >= 5) {
  //       return 'smallTxt';
  //     }
  //
  //     return '';
  //   }
  //
  //   return '';
  // }, [totalOdd]);

  return reportList.length ? (
    <div className='gameCenterHeaderContainer'>
      {isMobile() && (
        <div className='gameCenterMultiplierContainer'>
          {reportList.map((el, index) => {
            const fishResult = reportList[index];
            // const key = `${index}_${fishResult?.resultType}_${fishResult?.odd}_${fishResult?.animation}`;
            return (
              <div
                // key={key}
                className={`gameCenterMultiplierInnerWrapper ${!index ? 'active' : ''} ${
                  fishResult?.animation ? 'fish-row-animation' : ''
                }`}
              >
                <div className='gameCenterMultiplierInner'>
                  <span className='gameFishMultiplierTxt smallTxt'>
                    {fishResult?.odd !== undefined ? `x${fishResult?.odd}` : ' '}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
      <div className='gameCenterHeaderImgContainer'>
        <p className='gameCenterHeaderMultiplierTxt'>
          {/*todo add class pulsing to span for animated coefficient*/}
          {t(globalTranslationKeys.TotalOdd)}:{' '}
          <span className={showPulsing ? 'pulsing' : ''}>x{totalOdd}</span>
        </p>
      </div>
    </div>
  ) : (
    <></>
  );
});
